/*
  BUY BOX — compact size chips

  Rewrites the size option's labels for display only: the paper size becomes the
  headline of each chip and the dimensions drop to a small second line, so five
  full-width pills become two rows of chips.

  Nothing about the product is changed. The value the label is built from is
  still the variant's real option value — if this script never runs, or a value
  does not match the expected shape, the original label is left exactly as it is.

  Only the option whose name contains "size" is touched. The county, province,
  text and print-option pickers keep their labels untouched.
*/
(function () {
  var SIZE_OPTION = /size/i;

  /*
    Two shapes appear in this catalogue:
      "A5 – 14.8 × 21 cm (5.8 × 8.3 in)"   (70 products)
      "A5 148 x 210mm"                      (a handful of older ones)
    Anything else — "Dublin", "Queen of Mayo", "Bundle A" — matches neither and
    is left alone, which is why the name part is capped at four characters and
    the second pattern insists on a digit.
  */
  var DASHED = /^\s*([A-Za-z0-9]{1,4})\s*[–—-]\s*(.+)$/;
  var SPACED = /^\s*([A-Za-z0-9]{1,4})\s+(\d.*)$/;

  /*
    Falls back to converting when a value carries no bracketed inches — the
    "A5 148 x 210mm" products. Matches the size guide's arithmetic, which also
    works from the metric figure rather than the brackets.
  */
  function toInches(metric) {
    var isMm = /mm/i.test(metric);
    var pair = metric.replace(/[^0-9.×xX\s]/g, ' ').split(/[×xX]/);
    if (pair.length !== 2) return '';

    var w = parseFloat(pair[0]);
    var h = parseFloat(pair[1]);
    if (!w || !h) return '';

    if (isMm) {
      w = w / 10;
      h = h / 10;
    }

    return round1(w / 2.54) + ' × ' + round1(h / 2.54) + ' in';
  }

  function round1(n) {
    return Math.round(n * 10) / 10;
  }

  function relabel(root) {
    /*
      'metric' | 'imperial' | 'both', decided in Liquid from the visitor's
      market so the chips and the size guide always agree. Falls back to metric
      if the attribute is missing.
    */
    var units = root.getAttribute('data-ms-units') || 'metric';
    var fieldsets = root.querySelectorAll('.product-form__input--pill');

    for (var i = 0; i < fieldsets.length; i++) {
      var fieldset = fieldsets[i];
      var legend = fieldset.querySelector('legend');
      if (!legend || !SIZE_OPTION.test(legend.textContent)) continue;

      fieldset.classList.add('ms-size-chips');

      var labels = fieldset.querySelectorAll('label');
      for (var j = 0; j < labels.length; j++) {
        var label = labels[j];
        if (label.querySelector('.ms-chip')) continue; // already done

        var unavailable = label.querySelector('.label-unavailable');
        var raw = (label.childNodes[0] && label.childNodes[0].nodeValue
          ? label.childNodes[0].nodeValue
          : label.textContent).trim();

        var match = raw.match(DASHED) || raw.match(SPACED);
        if (!match) continue;

        var rest = match[2];
        var paren = rest.match(/\(([^)]+)\)/);
        var metric = rest.replace(/\s*\([^)]*\)\s*/, '').trim().replace(/(\d)\s*[xX]\s*(\d)/, '$1 × $2');

        /*
          Most values already state the inches in brackets, so use her own
          figures rather than recomputing and risking a rounding disagreement.
          The older millimetre values have no brackets — those get converted.
        */
        var imperial = paren ? paren[1].trim() : toInches(metric);

        var chip = document.createElement('span');
        chip.className = 'ms-chip';

        var name = document.createElement('span');
        name.className = 'ms-chip__name';
        name.textContent = match[1];

        chip.appendChild(name);

        if (units !== 'imperial') {
          var dim = document.createElement('span');
          dim.className = 'ms-chip__dim';
          dim.textContent = metric;
          chip.appendChild(dim);
        }

        if (units !== 'metric' && imperial) {
          var dimIn = document.createElement('span');
          dimIn.className = 'ms-chip__dim';
          /* Only dimmed when it is the second line; on its own it is the line. */
          if (units === 'both') dimIn.className += ' ms-chip__dim--in';
          dimIn.textContent = imperial;
          chip.appendChild(dimIn);
        }

        label.textContent = '';
        label.appendChild(chip);
        if (unavailable) label.appendChild(unavailable);

        /*
          The visible text loses the inches, so hand the full original value to
          assistive tech on the input the label points at.
        */
        var input = label.htmlFor ? document.getElementById(label.htmlFor) : null;
        if (input && !input.getAttribute('aria-label')) {
          input.setAttribute('aria-label', raw);
        }
      }

      addSizeGuideLink(fieldset, legend);
    }
  }

  /*
    A "Size guide" link beside the Size label, but only when the size guide
    section is actually on the page — an anchor to a section someone has removed
    would scroll nowhere, so the link is added from the DOM rather than printed
    unconditionally in Liquid.
  */
  function addSizeGuideLink(fieldset, legend) {
    if (!document.getElementById('ms-size-guide')) return;
    if (fieldset.querySelector('.ms-size-guide-link')) return;

    var link = document.createElement('a');
    link.className = 'ms-size-guide-link';
    link.href = '#ms-size-guide';
    link.textContent = 'Size guide';
    legend.insertAdjacentElement('afterend', link);
  }

  function init() {
    var infos = document.querySelectorAll('product-info');

    for (var i = 0; i < infos.length; i++) {
      (function (info) {
        relabel(info);

        /*
          Choosing a variant makes the theme re-render this whole element from
          the Section Rendering API, which throws away our chips. Re-running on
          mutation puts them back. relabel() is idempotent, so the mutations it
          causes settle after one extra no-op pass rather than looping.
        */
        new MutationObserver(function () {
          relabel(info);
        }).observe(info, { childList: true, subtree: true });
      })(infos[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
